import axios from "axios";

import ENV from "../env";

export default {
  create: (data) => {
    return axios(`${ENV.v2Path}/warranty_programs`, {
      method: "POST",
      data
    });
  },
  get: (id) => {
    return axios(`${ENV.v2Path}/warranty_programs/${id}`, {
      method: "GET"
    });
  },
  getAll: (activeOnly) => {
    return axios(`${ENV.v2Path}/warranty_programs`, {
      method: "GET",
      params: { active_only: activeOnly }
    });
  },
  update: (data) => {
    return axios(`${ENV.v2Path}/warranty_programs/${data.id}`, {
      method: "PUT",
      data
    });
  }
};
